import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts'

import type { TeamComparison } from '@/hooks'

// 团队颜色
const TEAM_COLORS = [
  '#3B82F6', // blue
  '#10B981', // green
  '#F59E0B', // amber
  '#8B5CF6', // purple
  '#EC4899', // pink
  '#06B6D4', // cyan
  '#84CC16', // lime
  '#F97316', // orange
]

interface TeamComparisonChartProps {
  data: TeamComparison[]
  onBarClick?: (teamId: string) => void
}

export function TeamComparisonChart({ data, onBarClick }: TeamComparisonChartProps) {
  if (data.length === 0) {
    return (
      <div className="text-muted-foreground flex h-[300px] items-center justify-center">
        暂无数据
      </div>
    )
  }

  const chartData = data.map((item, index) => ({
    ...item,
    name: item.teamName,
    value: item.memberCount,
    color: TEAM_COLORS[index % TEAM_COLORS.length],
  }))

  const handleClick = (entry: (typeof chartData)[0]) => {
    if (onBarClick) {
      onBarClick(entry.teamId)
    }
  }

  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 5, right: 30, left: 80, bottom: 5 }}
        >
          <XAxis type="number" allowDecimals={false} />
          <YAxis type="category" dataKey="name" width={80} tick={{ fontSize: 12 }} />
          <Tooltip
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            content={({ active, payload }: { active?: boolean; payload?: any }) => {
              if (active && payload && payload.length) {
                const data = payload[0].payload as (typeof chartData)[0]
                return (
                  <div className="bg-background rounded-lg border p-3 shadow-lg">
                    <p className="font-medium">{data.teamName}</p>
                    <p className="text-muted-foreground text-sm">负责人: {data.leaderName}</p>
                    <p className="text-muted-foreground text-sm">成员数: {data.memberCount} 人</p>
                  </div>
                )
              }
              return null
            }}
          />
          <Bar
            dataKey="value"
            radius={[0, 4, 4, 0]}
            onClick={(_, index) => handleClick(chartData[index])}
            style={{ cursor: onBarClick ? 'pointer' : 'default' }}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
